import axios from 'api/axios'
import {
	AllowedModule,
	ClientInvoiceDetails,
	ClientTaxation,
	Currency,
	CurrentLimit,
	EdgePlatform,
	PlatformStack,
} from 'types'
import handleAxiosError from 'utils/handleAxiosError'

/**
 * Type Interface of objects that can be used in the API for editClient
 */

export interface EditClientBody {
	plan: {
		title: string
		storageAllowed: number
		billingCycle: 'MONTHLY' | 'YEARLY'
		perMonth: number
		perYear: number
		modules: AllowedModule[]
		voiceCalling?: {
			enabled: boolean
			pricing?: {
				currency?: string // Optional - uses client's default currency if not provided
				virtualNumberSetupFee: number
				virtualNumberMonthlyRental: number
				perChannelMonthlyRental: number
				numberOfChannels: number
				inboundPerMinuteRate: number
				outboundPerMinuteRate: number
			}
		}
		aiServices?: {
			enabled: boolean
			pricing?: {
				currency: string
				perTokenRate: number
				perTranscriptionMinuteRate?: number
				perDocumentIntelligenceUnitRate?: number
			}
		}
	}
	limit: CurrentLimit
	logo?: string
	organizationName: string
	email: string
	address?: string
	city?: string
	state?: string
	website?: string
	country: string
	mobileNumber: {
		mobile: string
		country: string
	}
	whatcxCharge: number
	whatcxChargeInbound: number
	whatcxChargeOutbound: number
	currency_selected: Currency
	taxation: ClientTaxation[]
	invoiceDetails: ClientInvoiceDetails[]
	csmUser: string[]
	notificationEmails?: string
	shouldGenerateAutoInvoice: boolean
	invoiceEmails?: string
	platform: EdgePlatform
	platformStack?: PlatformStack
	tdsEnabled: boolean
	broadcastLimit: number
	enablexVoice?: {
		appId: string
		appKey: string
		fromNumber: string
		webhookUrl?: string
		isConfigured: boolean
	}
	aiPlatformConfig?: {
		credentialMode: 'shared' | 'byok'
		openai?: {
			apiKey?: string
			defaultModel?: string
		}
	}
}

/**
 * Type Interface for the Response object you get from editClient request if successful
 */
export interface AddClientResponse {
	statusCode: number
	message: string
}

/**
 * API call edit a Clients
 * @param body editClientBody - data to be send to backend for edit client
 * @returns AdminResponse - Response object returned from the server
 */

export const editClient = async (id: string, body: EditClientBody) => {
	try {
		const { data } = await axios.put<AddClientResponse>(`client/edit/${id}`, body)

		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default editClient
